import "./App.css";

import { AboutPage } from "./components/about/about";
import { Skills } from "./components/skills/skills";
import { Navbar } from "./components/navbar/navbar";
import { Projects } from "./components/projects/projects";
import { Contact } from "./components/contact/contact";
import { Education } from "./components/education/education";
import { AllRoutes } from "./Routes/Routes";
import { HomePage } from "./components/home/home";
import { Review } from "./components/Reviews/reviews";
import { AllProjects } from "./components/projects/allProjects";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);

  return (
    <div className="App">
      <Navbar />

      <HomePage />

      <AboutPage />
      {/* <Education /> */}

      <Skills />

      <Projects />
      <AllProjects />
      <Review />
      <Contact />
      <AllRoutes />
    </div>
  );
}

export default App;
